<template>
  <div class="mb-4">

    <!--#region -- Content ---->
    <!--#region SFDC Synchronization Real Data-->
    <div class="caption-label-hide d-flex">
      <div class="caption-label">
        <b-badge style="margin-right: 10px;" v-if="sfdcAttachments" variant="primary">{{sfdcAttachments.length}}</b-badge>
        <b-badge style="margin-right: 10px;" v-else variant="primary">0</b-badge>
        Attachments
        <b-button v-b-toggle.collapseDemoLoans
                  variant="outline-primary"
                  class="text-primary text-left"
                  style="background-color: white; border: none;">
          <b-icon :icon="isCollapsed ? 'chevron-down' : 'chevron-up'"></b-icon>
        </b-button>
        <!--
      <div>
    <b-alert v-if="!sfdc_demo_loans_loading" show dismissible variant="primary">
      Click to expand the <b>Salesforce Demo Loans </b>details.
    </b-alert>
  </div>
    -->
      </div>
    </div>

    <b-collapse id="collapseDemoLoans" visible @shown="onShown" @hidden="onHidden" accordion="Salesforce Attachments" role="tabpanel">

      <div style="padding-top: 10px;" v-if="sfdcAttachments">
        <b-table :fields="sfdcAttachmentFields" :items="sfdcAttachments"
                 small
                 thead-class="thead-light text-dark"
                 :busy="searching"
                 style="width: calc(100% - 10px)">
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <!-- https://localhost:8080/opportunity/demo-loan/id/a0ZEi0000022XpxMAE-->
          <template #cell(attachment_name)="data">
            <div v-if="checkActionEnable() && data.item && data.item.attachment_id !== null">
              <a class="link" @click="downloadSfdcAttachment(data.item.attachment_id, data.item.attachment_name)">{{ data.item.attachment_name }}</a>
            </div>
            <div v-else>
              {{data.item.attachment_name}}
            </div>
          </template>
          <template #cell(file_size)="data">
            <div v-if="data.item && data.item.file_size !== null">
              {{data.item.file_size}}KB
            </div>
            <div v-else>
              0KB
            </div>
          </template>
        </b-table>
      </div>
    </b-collapse>

    <!--#endregion-->
    <!-- #endregion Modal-->
  </div>
</template>

<script>
  export default {
    name: 'sfdc-attachments',
    props: {
      prop_attachment_link_type: {
        default: null
      },
      prop_sfdc_attachments: {
        default: null
      },
      prop_user_sites: {
        default: null
      },
      prop_user: {
        default: null
      },

    },
    data: function () {
      return {
        isRouterAlive: true,
        dateFormat: { year: 'numeric', month: 'short', day: 'numeric' },
        sfdcAttachments: null,
        sfdcAttachmentsOriginal: null,
        fixModel: true,
        fixCustomizationPn: "Customization",
        basicInfo: null,
        loginUser: null,
        userSites: null,
        actionEnable: false,
        frontEndUrlToUse: this.$session.get('frontEndUrlToUse'),
        createBy: null,
        searching: false,
        noneSelectedHint: '',
        sfdcAttachmentFields: [
          { key: 'attachment_name', label: 'Name', thClass: 'align-middle', sortable: true },
          { key: 'file_size', label: 'Size', thClass: 'align-middle', sortable: true },
          { key: 'create_by_name', label: 'Create By', thClass: 'align-middle', sortable: true },
          { key: 'owner_name', label: 'Owner', thClass: 'align-middle', sortable: true },
          { key: 'created_date', label: 'Create Date', thClass: 'align-middle', sortable: true },
        ],
        
        reloadBusy: false,
        isCollapsed: false,
      }
    },
    computed: {
      userFunctions() {
        return this.$session.get('user_functions');
      },
      userRoles() {
        return this.$session.get('user_roles');
      },

    },
    created() {
      let self = this;
      self.sfdcAttachments = self.prop_sfdc_attachments;
      self.sfdcAttachmentsOriginal = self.prop_sfdc_attachments;
      self.userSites = self.prop_user_sites;
      self.loginUser = self.prop_user;
      self.createBy = self.prop_user;
      self.actionEnable = self.checkActionEnable();
      // console.log("SFDC Copo actionEnable:");
      // console.log(self.actionEnable);
    },
    methods: {
      prdEnv() {
        return 'PRD' === this.$session.get('mode');
      },
      onShown() {
        this.isCollapsed = false;
      },
      onHidden() {
        this.isCollapsed = true;
      },

      checkActionEnable() {
        let self = this;
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }

        if (self.loginUser === 'power') {
          return true;
        }

        // loginUser is gtc owner
        if (self.loginUser !== null && self.createBy !== null && self.loginUser === self.createBy) {
          return true;
        }
        if (self.userRoles !== null && _.size(self.userRoles) > 0) {
          if (_.indexOf(self.userRoles, 'ES_PM_Leader') > -1 || _.indexOf(self.userRoles, 'Admin') > -1 || _.indexOf(self.userRoles, 'ES_PM') > -1) {
            return true;
          }
        }
        if (self.userFunctions !== null && _.size(self.userFunctions) > 0) {
          if (_.indexOf(self.userFunctions, 'ES PM Leader') > -1 || _.indexOf(self.userFunctions, 'Tech Leader') > -1) {
            return true;
          }
        }
        //login_user_name === ftie_page_obj.gtc_owner || login_user_name === 'power' || (userRoles !== null && userRoles.includes('Admin')))
        return false;
      },

      downloadSfdcAttachment(attachment_id, file_name) {
        let self = this;
        let url = self.$root.baseUrl + '/engineering-service/attachment/download/';
        let request_data = {
          user_name: self.loginUser,
          attachment_id: attachment_id,
          file_name: file_name
        };
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params, responseType: 'arraybuffer' })
          .then((response) => {

            if (response.status === 200) {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              //console.log("file_name =" + file_name);
              link.setAttribute('download', file_name);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          })

      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/framework-sfdc/SfdcAttachments.vue